// import { MarkerType } from 'reactflow';

export const initialNodes = [
  { id: 'start', type: 'start', position: { x: 50, y: 100 }, data: { label: 'start' } },
];
export const initialEdges = [
  // { id: 'e1-2', source: 'start', target: 'todo', type: 'custom', label: 'edge-1', markerEnd: { type: MarkerType.ArrowClosed, } }
];
